module.exports = __webpack_public_path__ + "static/media/Coins_Default@3x.f972744e.png";